const initialState = {
	region: undefined,
	zip: undefined,
};

const geoTargetingReducer = (state = initialState) => state;

export default geoTargetingReducer;
